module.exports = __webpack_public_path__ + "static/media/sell_change_request_3-2.d304d639.png";